import { ReferenceEntity } from 'src/utils/reference-schema';
import { TypeDefinitionContext, useTypeDefinition } from './type-definition-context';
import { TypeDefinitionIndent } from './type-definition-indent';
import { TypeDefinitionPair } from './type-definition-pair';

/** Renders the arguments of a function in a type definition. */
export const TypeDefinitionParameters = () => {
  const {
    entity,
    indent = 0,
    ...ctx
  } = useTypeDefinition();
  const syntax = 'list';
  const length = getParamsLength(entity);
  const shouldUseNewLines = length > 45;
  const newIndent = shouldUseNewLines ? indent + 1 : indent;
  return <>
      {shouldUseNewLines && '\n'}
      {entity.parameters?.map((parameter, i, arr) => {
      const isLastParameter = i === arr.length - 1;
      let punctuation = isLastParameter ? '' : ', ';
      if (shouldUseNewLines) {
        punctuation = isLastParameter ? '\n' : ',\n';
      }
      return <TypeDefinitionContext.Provider key={parameter.key} value={{
        entity: parameter,
        indent: newIndent,
        ...ctx,
        syntax
      }}>
            <TypeDefinitionIndent />
            <TypeDefinitionPair />
            <span className="token punctuation">{punctuation}</span>
          </TypeDefinitionContext.Provider>;
    })}
    </>;
};
const getParamsLength = (entity: ReferenceEntity) => {
  const keyTypePairs = entity.parameters?.map(parameter => `${parameter.key}: ${parameter.type}`);
  return keyTypePairs?.join(', ').length ?? 0;
};